import { useResourceParams } from '@refinedev/core';
import { useMemo } from 'react';
import { Outlet } from 'react-router';

import SpinLoading from '@/components/general/SpinLoading';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useInitialLoading } from '@/hooks/useInitialLoading';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';
import { RESOURCES } from '@/Resources';

const ShipmentSection = () => {
  const { action } = useResourceParams();

  useDocumentTitle({
    resourceTitle: 'Envíos',
    showTitle: 'Envío {id}',
    editTitle: 'Editar envío {id}',
    createTitle: 'Nuevo envío',
  });
  const { selectProps: companySelectProps } = useSelectScrollSearch(
    {
      resource: 'empresas',
      optionLabel: (item: any) => item.full_name,

      queryOptions: {
        queryKey: ['empresas'],
      },
    },
    {
      saveItem: true,
    },
  );
  const { selectProps: technicianSelectProps } = useSelectScrollSearch({
    resource: 'empresas',
    optionLabel: (item: any) => item.full_name,
    meta: {
      type: 5,
      id: 'technician',
    },
    queryOptions: {
      queryKey: ['empresas', 'technicians'],
    },
  });
  const { selectProps: shippersSelectProps } = useSelectScrollSearch({
    resource: RESOURCES.SHIPPERS,
    optionLabel: (item: any) => item.name,
  });
  const { selectProps: ticketsSelectProps } = useSelectScrollSearch(
    {
      resource: RESOURCES.TICKETS,
      optionLabel: (item: any) =>
        `${item.id} - ${item.title ? item.title : item.ticket_title_str ? item.ticket_title_str : '-'}`,
      optionValue: (item: any) => item.id,
      meta: { saveItem: action == 'list' ? true : undefined },
    },
    { saveItem: true },
  );
  const isLoading = useMemo(
    () =>
      companySelectProps.loading ||
      shippersSelectProps.loading ||
      ticketsSelectProps.loading ||
      technicianSelectProps.loading,
    [
      companySelectProps.loading,
      shippersSelectProps.loading,
      ticketsSelectProps.loading,
      technicianSelectProps.loading,
    ],
  );
  const { initialLoading } = useInitialLoading(isLoading);

  return (
    <div className="ShipmentSection MainSection">
      {initialLoading ? (
        <SpinLoading />
      ) : (
        <Outlet
          context={{
            companySelectProps,
            shippersSelectProps,
            technicianSelectProps,
            ticketsSelectProps,
          }}
        />
      )}
    </div>
  );
};

export default ShipmentSection;
